import { CompetitionData } from "./types";

const CompetitionItemBody = ({ item }: { item: CompetitionData }) => {
  if (item.CompetitionTypePrefix === "SC") {
    return null;
  }
  if (item.IsRewardCompetition) {
    return (
      <div className="relative mb-[18px]" data-prize-id={item.CtaAddToBasketPrizeId}>
        <div className="text-[#898994] text-center font-roboto text-[9px] lg:text-[11px] font-medium uppercase">
          {item.TicketText}
        </div>
        <div className="text-center font-roboto text-base lg:text-xl leading-5.5 lg:leading-6.5 font-bold text-black">
          {item.CtaTicketValue}
        </div>
      </div>
    );
  }
  return (
    <div className="relative mb-1 lg:mb-2" data-prize-id={item.CtaAddToBasketPrizeId}>
      <div className="text-[#898994] text-center font-roboto text-[9px] lg:text-[11px] font-medium uppercase">
        {item.TicketText}
      </div>
      <span
        className={`relative  text-[#28282B] text-base lg:text-xl font-bold leading-5.5 lg:leading-6.5 mx-0 ${item.FormattedPrice !== item.FormattedOriginalPrice ? "text-[#FF8200] text-center font-bold mr-[4px]" : ""}`}>
        {item.CurrencySymbol}
      </span>
      <span
        className={`text-center font-roboto text-base lg:text-xl leading-5.5 lg:leading-6.5 font-bold mr-[4px] ${item.FormattedPrice !== item.FormattedOriginalPrice ? "text-[#FF8200]" : "text-black"}`}>
        {item.FormattedPriceWithoutCurrency}
      </span>
      {item.FormattedPrice !== item.FormattedOriginalPrice && (
        <span className="relative line-through text-[#898994] text-sm mr-1.0 font-roboto mr-[4px]">
          {item.FormattedOriginalPrice}
        </span>
      )}
      {item.PercentOffValue > 0 && item.OverrideDiscountValue === null && (
        <span className="relative text-[#FF8200] font-roboto text-sm font-normal">-{item.PercentOffValue}%</span>
      )}
      {item.PercentOffValue > 0 && item.OverrideDiscountValue !== null && (
        <span className="relative text-[#FF8200] font-roboto text-sm font-normal">-{item.OverrideDiscountValue}%</span>
      )}
    </div>
  );
};

export default CompetitionItemBody;
